module.exports = __webpack_public_path__ + "img/baas_38.9f5fcd31.png";